const SHOW_CTX = 'SHOW_CONTEXT';
const HIDE_CTX = 'HIDE_CONTEXT';

export function showCTXMenu({ items, parent = {}, width = 150, title = '' }) {
    return {
        type: SHOW_CTX,
        items,
        parent,
        title,
        width,
    };
}

export function hideCTXMenu() {
    return {
        type: HIDE_CTX
    };
}

const initialState = {
    showCTX: false,
    title: '',
    items: [],
    parent: {},
    width: 150,
};

export default function CTXMenu(state = initialState, action) {
    switch (action.type) {
        case SHOW_CTX:
            return {
                showCTX: true,
                items: action.items,
                parent: action.parent,
                title: action.title,
                width: action.width
            };

        case HIDE_CTX:
            return initialState;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/contextMenu.js